/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { unitInstallmentPrint } from "../../../utils/printFroms";

class Installments extends Component {
  state = {
    data: {
      unitName: "",
      categoryId: "",
      subcategoryId: "",
      blockName: "",
      floorNum: "",
      ownerId: "",
    },
    Username: "",
    allCategory: [],
    allSubcategory: [],
    allOwner: [],

    contentHeader: "Installments",
    addButtonLabel: "اضافة وحدة سكنية",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetInstallments",
    singleItemUrl: "/api/data/GetUnit",
    addUrl: "/api/data/AddUnit",
    editUrl: "/api/data/EditUnit",
    deleteUrl: "/api/data/DeleteUnit",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة وحدة سكنية",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل وحدة سكنية",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  handlePrint(row) {
    post(
      "/api/data/GetUnitInstallments",
      { unitId: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      unitInstallmentPrint(
        apiResponse.data.respData.data,
        row,
        this.state.Username
      );
    });
  }

  componentDidMount() {
    this.getData();
    this.setState({
      Username: sysJwt.getUsername(),
    });
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.unitName"),
        field: "UNIT_NAME",
      },
      {
        id: 2,
        label: t("col.ownerName"),
        field: "OWNER_NAME",
      },
      {
        id: 3,
        label: t("col.block"),
        field: "BLOCK_NAME",
      },
      {
        id: 4,
        label: t("col.price"),
        field: "PRICE",
      },
      {
        id: 5,
        label: t("col.remainingAmount"),
        field: "REMAINING_AMOUNT",
      },
      {
        id: 6,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              <div className="inner" title="Show Installments Recoreds">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    window.location.replace(
                      "/dashboard/unitinstallments?unitId=" +
                        data.ID +
                        "&unitName=" +
                        data.UNIT_NAME +
                        "&ownerName=" +
                        data.OWNER_NAME
                    )
                  }
                >
                  <i className="fa fa-bars" />
                </button>
              </div>
              <div className="inner" title="Print Intallment">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handlePrint(data);
                  }}
                >
                  <i className="fa fa-print" />
                </button>
              </div>
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.installments")}</h4>
          </div>
        </div>
        <hr />
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Installments);
